import React from 'react';
import gql from 'graphql-tag';
import { Location } from 'history';

import { FeaturedListingModuleFragment } from './featured_listing_module';
import { Item2PaidLandingData } from '../schemas/rql';
import SimilarListingsRowWithQuery from './discovery/similar_listings_row_with_query';

import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { localizedSimilarListingsTitle, showItemPageListingFlags } from '@reverbdotcom/commons/src/localize_listing_rows_utils';

export const Item2PaidLandingFragment = gql`
  fragment Item2PaidLandingData on Listing {
    _id
    id
    ...FeaturedListingModuleData
  }
  ${FeaturedListingModuleFragment}
`;

interface IProps extends IUserContext {
  listing: Item2PaidLandingData.Fragment;
  location: Location;
}

const COMPONENT_NAME = 'Item2PaidLanding';

export function Item2PaidLanding(props: IProps) {
  const { listing, location } = props;
  const medium = location?.query?.utm_medium;
  const qualifiedMediums = ['ad', 'cpc'];
  const user = useUser();

  const unqualifiedView = [
    listing.state !== 'live',
    !qualifiedMediums.includes(medium),
  ].some(Boolean);

  const mParticleViewData = {
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ComponentView,
  };

  useViewTracking(mParticleViewData, !unqualifiedView);

  if (unqualifiedView) { return null; }

  return (
    <div className="scaling-pb-3 mobile-pt-1 minimal-listing-row">
      <SimilarListingsRowWithQuery
        listingId={listing.id}
        title={localizedSimilarListingsTitle(user)}
        eventName={MParticleEventName.ViewedItemPaidHeaderSimilarListings}
        showFlags={showItemPageListingFlags(user)}
      />
    </div>
  );
}

export default withUserContext<IProps>(Item2PaidLanding);
